import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Monogram } from "@/components/Monogram";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password.trim());
      toast.success("Welcome back, Apostle.");
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-parchment grain flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <Monogram size={56} />
          <h1 className="mt-4 font-serif text-3xl font-semibold">Admin Login</h1>
          <p className="text-sm text-parchment/60 mt-1">Charles McKuhn Ministries</p>
        </div>
        <form
          data-testid="login-form"
          onSubmit={submit}
          className="rounded-3xl border border-gold/20 bg-white/[0.04] p-8 backdrop-blur-sm"
        >
          <label className="block text-sm mb-2">Email</label>
          <input
            data-testid="login-email"
            type="email"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-xl bg-ink border border-white/15 focus:outline-none focus:ring-2 focus:ring-gold mb-4"
            placeholder="you@email.com"
          />
          <label className="block text-sm mb-2">Password</label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-xl bg-ink border border-white/15 focus:outline-none focus:ring-2 focus:ring-gold mb-6"
            placeholder="••••••••"
          />
          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-full bg-gold text-ink font-semibold hover:bg-gold-light transition-colors disabled:opacity-60"
          >
            {busy ? <Loader2 size={18} className="animate-spin" /> : <Lock size={16} />}
            Sign In
          </button>
        </form>
        <button
          onClick={() => navigate("/")}
          className="mt-6 w-full text-center text-sm text-parchment/50 hover:text-gold-light transition-colors"
        >
          ← Back to site
        </button>
      </div>
    </div>
  );
}
